import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, BookOpen, ClipboardCheck, Clapperboard, LayoutDashboard } from 'lucide-react';
import axios from 'axios';
import AppSidebar from '../layout/AppSidebar/AppSidebar';

const Navbar = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("admin_token");
        localStorage.removeItem("role");
        navigate("/login");
        window.location.reload();
    };

    // Bandlar, path'lar va matnlar avvalgidek; faqat guruhlarga ajratilgan.
    const groups = [
        {
            label: "Asosiy",
            items: [
                { to: "/", label: "Dashboard", icon: LayoutDashboard },
            ],
        },
        {
            label: "Ta'lim",
            items: [
                { to: "/courses", label: "My courses", icon: BookOpen },
                { to: "/lesson-confirmation", label: "Confirmation", icon: ClipboardCheck },
            ],
        },
        {
            label: "Video",
            items: [
                { to: "/new-lesson", label: "Video generate", icon: Clapperboard },
                { to: "/status", label: "Video generating status", icon: Activity },
            ],
        },
    ];

    return <AppSidebar groups={groups} onLogout={handleLogout} />;
}

export default Navbar;
